<div class="space-y-2">
  <div *ngFor="let option of options; trackBy: trackByOption">
    <lis-checkbox [innerLabel]="option.innerLabel" [control]="getCheckboxControlByKey(option.key)"></lis-checkbox>
  </div>
</div>
